/**
 * PATH: apps/quote/src/components/builder/scope-ag-grid/ScopeAgGridChrome.tsx
 * FILE_ID: QB-AGGRID-CHROME-001
 * PURPOSE: Compose the SAM-style header chrome that sits above the
 *          AG-Grid: section toolbar + CLIENT VIEW banner (conditional).
 *          Pure layout — no state, no callbacks beyond forwarding.
 * WHY: ScopeAgGridSection grew past 300 lines once the context-menu
 *      wiring landed in MR 8; extracting the static header chrome
 *      keeps both files focused on one responsibility.
 * RELATED:
 *   - QB-AGGRID-TOOLBAR-001 (ScopeSectionToolbar) — child
 *   - QB-AGGRID-BANNER-001 (ScopeClientViewBanner) — child
 *   - QB-AGGRID-SECTION-001 — consumer
 */

import ScopeSectionToolbar, {
  type ScopeGridDensity,
} from './ScopeSectionToolbar'
import ScopeClientViewBanner from './ScopeClientViewBanner'

export interface ScopeAgGridChromeProps {
  sectionId?: string
  sectionTitle: string
  itemCount: number
  sectionSubtotal?: string | number | null
  density: ScopeGridDensity
  onDensityChange: (next: ScopeGridDensity) => void
  isEditable: boolean
  onResetWidths: () => void
  onAddRow: () => void
  onAddSection: () => void
  onAddLumpSum?: () => void
  onOpenPricelist?: () => void
  onToggleClientLabels: () => void
  isClientLabelsOn: boolean
  clientVisibleLabels: string[]
}

export default function ScopeAgGridChrome(props: ScopeAgGridChromeProps) {
  return (
    <>
      <ScopeSectionToolbar
        sectionId={props.sectionId}
        sectionTitle={props.sectionTitle}
        itemCount={props.itemCount}
        sectionSubtotal={props.sectionSubtotal}
        density={props.density}
        onDensityChange={props.onDensityChange}
        isEditable={props.isEditable}
        onResetWidths={props.onResetWidths}
        onAddRow={props.onAddRow}
        onAddSection={props.onAddSection}
        onAddLumpSum={props.onAddLumpSum}
        onOpenPricelist={props.onOpenPricelist}
        onToggleClientLabels={props.onToggleClientLabels}
        isClientLabelsOn={props.isClientLabelsOn}
      />
      {props.isClientLabelsOn && (
        <ScopeClientViewBanner
          visibleColumnLabels={props.clientVisibleLabels}
        />
      )}
    </>
  )
}
